import { render } from "./MFACreate.vue?vue&type=template&id=22384cc4"
import script from "./MFACreate.vue?vue&type=script&lang=js"
export * from "./MFACreate.vue?vue&type=script&lang=js"
script.render = render

export default script